if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          // console.log('event',event);
          // console.log('event.source',event.source);
          // console.log('event.cartData.items',event.cartData.items);
          // console.log('this.dataset.index',this.dataset.index);
          // console.log('event.variantId',event.variantId);
          // console.log('typeof event.variantId',typeof event.variantId);
          if (event.source === 'quick-add') {
            // console.log('XYZ quick-add-bulk.js RETURN1');
            return;
          }

          if (!(event.variantId == parseInt(this.dataset.index))) {
            // console.log('RETURN event.variantId !== this.dataset.index');
            if (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) {
              // console.log('XYZ quick-add-bulk.js RETURN2');
              return;
            }
          }

          /* commented out, split logic into two pieces in the lines above this */
          // if (
          //   event.source === 'quick-add' ||
          //   (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
          //   (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          // ) {
          //   return;
          // }

          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        // console.log('quick-add-bulk.js listenForKeydown()');
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        // console.log('quick-add-bulk.js cleanErrorMessageOnType()');
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        // console.log('XYZ quick-add-bulk.js onCartUpdate()');
        // console.log('this.sectionId', this.sectionId);
        // console.log('this.dataset.index', this.dataset.index);
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              // console.log('responseText', responseText);
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              // console.log('this.sectionId', this.sectionId);
              // console.log('this.dataset.index', this.dataset.index);
              // console.log('html',html);
              // console.log('this',this);
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              // console.log(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              // console.log('sourceQty', sourceQty);
              if (sourceQty) {
                // console.log('%c sourceQty FOUND','background-color:red;color:white;font-size:16px');
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        // console.log('quick-add-bulk.js getSectionsUrl()');
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

      updateMultipleQty(items) {
        // console.log('XYZ quick-add-bulk.js updateMultipleQty()');
        this.selectProgressBar().classList.remove('hidden');

        let onlyOneProductInTheCart = false;
        /* was the most recent change to the cart increasing or decreasing a quantity? */
        let mostRecentChangeWasAdding = false;

        // console.log('updateMultipleQty(items) = items',items);

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            // console.log('parsedState', parsedState);
            if (parsedState?.items?.length == 1) {
              onlyOneProductInTheCart = true;
            }
            if (parsedState?.items_changelog?.added.length > 0) {
              mostRecentChangeWasAdding = true;
            }
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch(() => {
            // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
            // e.target.setCustomValidity(error);
            // e.target.reportValidity();
            // this.resetQuantityInput(ids[index]);
            // this.selectProgressBar().classList.add('hidden');
            // e.target.select();
            // this.cleanErrorMessageOnType(e);
          })
          .finally(() => {
            // console.log('this', this);
            // console.log('RUN FINALLY!');
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
            /* when customer adds the first item to their cart,
               we open the drawer cart
               to let them know the cart exists and show them the free gifts
               ...after the first product, they know about the cart already
                so we let them add items quickly
                without the cart opening and getting in the way every time
              */
            if (onlyOneProductInTheCart && Object.values(items) == 1 && mostRecentChangeWasAdding) {
              console.log('%c OPEN CART','background-color:red;color:white;font-size:16px');
              document.querySelector('cart-drawer').open()
            }
          });
      }

      getSectionsToRender() {
        // console.log('getSectionsToRender!!!');
        return [
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
        ];
      }

      renderSections(parsedState, ids) {
        // console.log('quick-add-bulk.js renderSections(parsedState, ids)');
        // console.log('parsedState',parsedState);
        // console.log('ids',ids);
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        // console.log('intersection',intersection)
        // console.log('intersection.length',intersection.length)
        if (intersection.length !== 0) return;
        // console.log('this.getSectionsToRender()');
        // console.log(this.getSectionsToRender());
        this.getSectionsToRender().forEach((section) => {
          // console.log('renderSections getSectionsToRender');
          // console.log('section',section);
          const sectionElement = document.getElementById(section.id);
          if (section.section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length.length === 0);
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }

          // console.log('sectionElement',sectionElement);
          // console.log('elementToReplace',elementToReplace);
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
